import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { SimpleFlowDetectionService } from '@app/shared/services/simple-flow-detection/simple-flow-detection.service';
import { PasswordChangeService } from '@app/shared/services/password-modification/password-change.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [{ provide: BsDropdownConfig, useValue: { autoClose: true } }]
})
export class NavbarComponent implements OnInit, OnDestroy {
  public masterSubscription: Subscription = new Subscription();
  public isLoggedIn: boolean;
  public userName: string;
  public passwordChangeService = inject(PasswordChangeService);
  public authService = inject(AuthService);
  public router = inject(Router);
  public route = inject(ActivatedRoute);
  public simpleFlowService = inject(SimpleFlowDetectionService);
  public isRouteBySimpleFlow$ = this.simpleFlowService.isSimpleFlow$();

  ngOnInit(): void {
    const sub = this.authService.getUser$()
      .subscribe(user => {
        this.isLoggedIn = user && !user.expired;
        this.userName = user ? user.profile.preferred_username : '';
      });
    this.masterSubscription.add(sub);
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  openSignInPopup(): void {
    this.authService.signIn$()
      .subscribe();
  }

  goToCreateAccount(): void {
    if (this.router.url.indexOf('/auth/create-account') === 0) {
      return;
    }

    const currentReturnUrl = this.route.snapshot.queryParams.returnUrl || '';
    const currentUrl = this.router.routerState.snapshot.url;
    const returnUrl = currentReturnUrl ? currentReturnUrl : currentUrl;

    this.router.navigate(['auth', 'create-account'], { queryParams: { returnUrl } });
  }

  onChangePassword() {
    this.passwordChangeService.changePassword(false);
  }

  signOut(): void {
    this.authService.signOut$()
      .subscribe();
  }
}
